import merge from 'lodash/merge';
import BackboneElement from '@/fhirworks/BackboneElement';
import ValueX from './types/ValueX';

/**
 * `content[x]` for Communication.payload.
 *
 * Follows the same pattern as client/src/fhirworks/types/DetailX.js — a ValueX subclass
 * whose base property is `content`, so the polymorphic accessors read `contentString`,
 * `contentAttachment` and `contentReference` while the serialized (Aidbox FCE) shape stays
 * `content: { string | Attachment | Reference }`.
 *
 * FHIR R4 only allows string | Attachment | Reference for content[x]; the other ValueX
 * slots are inherited but unused.
 */
export class ContentX extends ValueX {
    static __className = 'ContentX';

    constructor(constructJson) {
        super(constructJson, 'content', 'ContentX');
    }
}

/**
 * Communication.payload backbone element — one piece of message content.
 *
 * @property {ContentX} content
 */
export default class CommunicationPayload extends BackboneElement {
    static __className = 'CommunicationPayload';

    __objectStructure = {
        content: ContentX,
    };

    constructor(constructJson, className = 'CommunicationPayload') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
